import React from "react";
import { number } from "prop-types";

import { STATIC_KEYWORDS } from "../../../constants";

import "./ReadTime.m.css";

const ReadTime = ({ time }) => {
  const { READ_TIME_STRING } = STATIC_KEYWORDS;
  return (
    <span className="read-time" styleName="read-time">
      {`${time} ${READ_TIME_STRING}`}
    </span>
  );
};

ReadTime.defaultProps = {
  time: 0,
};

ReadTime.propTypes = {
  time: number.isRequired,
};

export default ReadTime;
